import { Button, Form, Input, Modal, message } from "antd";
import React from "react";
import { useMutation } from "@tanstack/react-query";
import { makeReservation } from "../../../utils/api";

function ReservationModal({ isModalOpen, onClose, title, reservationId }) {
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: (data) => makeReservation({ reservationId, ...data }),
    onSuccess: () => {
      message.success("Reservation successful!");
      form.resetFields();
      onClose();
    },
    onError: (error) => {
      message.error("Failed to make reservation.", error.message);
      console.error("Error making reservation:", error);
    },
  });

  const onFinish = (values) => {
    mutation.mutate({
      assigned_room: values.roomNumber,
    });
  };

  return (
    <Modal
      title={title || "Reservation Details"}
      open={isModalOpen}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        name="reservationForm"
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
      >
        <Form.Item
          name="roomNumber"
          rules={[{ required: true, message: "Please enter a room number" }]}
        >
          <Input placeholder="Please enter room number" className="py-2" />
        </Form.Item>

        <Button
          htmlType="submit"
          className="bg-[#55497C] text-white w-full p-5 mt-2"
          loading={mutation.isLoading}
        >
          Make a Reservation
        </Button>
      </Form>
    </Modal>
  );
}

export default ReservationModal;
